import { render, staticRenderFns } from "./Fragebogen.vue?vue&type=template&id=56dbfe5e&"
import script from "./Fragebogen.vue?vue&type=script&lang=js&"
export * from "./Fragebogen.vue?vue&type=script&lang=js&"
import style0 from "./Fragebogen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports